import React from "react";
import { Icon } from "tea-component";
import { useIntl } from 'umi';

export default function LodingData(props: any) {
  const { ifSearch = true, loadingHeight = 60 } = props;
  const { formatMessage } = useIntl(); // 中英切换方法

  return <div className="search-loading" style={{ height: `calc(${loadingHeight}vh)` }}>
    <div className="search-loading-box">
      <Icon type="loading" className="search-loading-icon" />
      {ifSearch ? formatMessage({ id: 'dbh_searching' }) : ''}
    </div>
  </div>
}